import { premiumCourseDestination } from '../../../utils/premiumCourseDestination';
import { Layout, Menu } from 'antd';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useEffect, useRef, useState } from 'react';
import {
  Bank,
  Calculator,
  ChartLineUp,
  Crown,
  CurrencyCircleDollar,
  GearSix,
  Books,
  GraduationCap,
  Question,
  SignOut,
  SquaresFour,
  UserGear,
  UsersThree,
  Video,
  Wallet,
  Cube,
} from '@phosphor-icons/react';
const { Sider } = Layout;
import { Container, HeaderSideBar } from './sideBarStyles';
import { useTitleAndUser } from '../../../hooks/userTitle';
import { handleToast } from '../../../components/Toast';
import { logout } from '../../../store/actions/AuthActions';
import { whatsAppLinkApi } from '../../../utils/apiWhatsapp';
import { logoBlackImg, smallLogoHeaderImg } from '../../../Constants/images';
import { TourGuideClient } from "@sjmc11/tourguidejs";
import { userRoutes } from '../../../utils/RoutesApi';
import axios from 'axios';

export function SideBar({ shortSideBar, setShortSidebar, isMobile }) {
  const hoveredRef = useRef(null);
  const history = useHistory();
  const [openKeys, setOpenKeys] = useState([]);
  const navigateCourse = async (path) => {
    try {
      const destination = path === '/cursos-premium'
        ? await premiumCourseDestination(permissions)
        : path;
      history.push(destination);
    } catch {
      handleToast(true, 'Não foi possível verificar seu acesso. Tente novamente.');
    }
  };

  const { title, permissions, setUser } = useTitleAndUser();
  const dispatch = useDispatch();
  const [width, setWidth] = useState(60);
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(false);

  const isPremium =
    (plan && ['premium'].includes(plan.NomePlano?.toLowerCase?.() || '')) ||
    (plan && plan?.currentPeriodEnd?.[0] === '3'); // handle infinite plan

  useEffect(() => {
    const fetchPlan = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}${userRoutes.STATUS_PAYMENT}`
        );
        setPlan(response.data);
      } catch (error) {
        setPlan(null);
      } finally {
        setLoading(false);
      }
    };

    fetchPlan();
  }, []);
  let path = window.location.pathname;
  path = path.split('/');
  path = path[path.length - 1];

  const navList = [
    {
      label: 'Painel administrativo',
      icon: <UserGear size="1.2rem" color="var(--Gray-gray-500, #757C8A)" />,
      submenu: [
        {
          label: 'Dashboard',
          path: '/admin-painel/dashboard',
        },
        {
          label: 'Feedback',
          path: '/admin-painel/feedback',
        },
        {
          label: 'Dados do usuário',
          path: '/admin-painel/user',
        },
        {
          label: 'Indices',
          path: '/admin-painel/indices',
        },
        // {
        //   label: 'Gestão de planos',
        //   path: '/admin-plan',
        // },
      ],
    },
    {
      label: 'Dashboard',
      icon: <SquaresFour size="1.2rem" />,
      path: '/dashboard',
    },
    {
      label: 'Carteira',
      icon: <Wallet size="1.2rem" />,
      path: '/wallet',
    },
    {
      label: 'Box de objetivos',
      icon: <Cube size="1.2rem" />,
      path: '/wallet?tab=4',
    },
    {
      label: 'Análise',
      icon: <ChartLineUp size="1.2rem" />,
      path: '/analysis',
    },
    {
      label: 'Renda passiva',
      icon: <CurrencyCircleDollar size="1.2rem" />,
      path: '/renda-passiva',
    },
    {
      label: 'Simuladores',
      icon: <Calculator size="1.2rem" />,
      path: '/simuladores',
    },
    {
      label: 'Imposto de renda',
      icon: <Bank size="1.2rem" />,
      path: '/imposto-renda',
    },
    {
      label: 'Cursos iBox6',
      key: 'cursos-ibox6',
      icon: <Books size="1.2rem" />,
      submenu: [
        { label: 'Premium', path: '/cursos-premium', key: 'cursos-premium' },
        { label: 'Gratuitos', path: '/cursos-gratuitos', key: 'cursos-gratuitos' },
      ],
    },
    {
      label: 'Tutorial',
      icon: <Video size="1.2rem" />,
      path: '/tutoriais',
    },
    {
      label: 'Educação',
      icon: <GraduationCap size="1.2rem" />,
      submenu: [
        {
          label: 'Aulas',
          path: '/Educacao',
        },
        {
          label: 'Gestão de vídeo',
          path: '/MyChannel',
        },
      ],
    },
    {
      label: 'Comunidade',
      icon: <UsersThree size="1.2rem" />,
      path: '/recommended-posts',
    },
    {
      label: isPremium ? 'Plano' : 'Seja Premium',
      icon: <Crown size="1.2rem" />,
      path: isPremium ? '/profile-edit' : '/pagamentos',
    },
    {
      label: 'Configurações',
      icon: <GearSix size="1.2rem" />,
      path: '/profile-edit',
    },
    {
      label: 'Suporte',
      icon: <Question size="1.2rem" />,
      path: '/suporte',
    },
  ];
  const navListSubChannel = [
    {
      label: 'Dashboard',
      icon: <SquaresFour size="1.2rem" />,
      path: '/dashboard',
    },
    {
      label: 'Carteira',
      icon: <Wallet size="1.2rem" />,
      path: '/wallet',
    },
    {
      label: 'Box de objetivos',
      icon: <Cube size="1.2rem" />,
      path: '/wallet?tab=4',
    },
    {
      label: 'Análise',
      icon: <ChartLineUp size="1.2rem" />,
      path: '/analysis',
    },
    {
      label: 'Renda passiva',
      icon: <CurrencyCircleDollar size="1.2rem" />,
      path: '/renda-passiva',
    },
    {
      label: 'Simuladores',
      icon: <Calculator size="1.2rem" />,
      path: '/simuladores',
    },
    {
      label: 'Imposto de renda',
      icon: <Bank size="1.2rem" />,
      path: '/imposto-renda',
    },
    {
      label: 'Cursos iBox6',
      key: 'cursos-ibox6',
      icon: <Books size="1.2rem" />,
      submenu: [
        { label: 'Premium', path: '/cursos-premium', key: 'cursos-premium' },
        { label: 'Gratuitos', path: '/cursos-gratuitos', key: 'cursos-gratuitos' },
      ],
    },
    {
      label: 'Tutorial',
      icon: <Video size="1.2rem" />,
      path: '/tutoriais',
    },
    {
      label: 'Educação',
      icon: <GraduationCap size="1.2rem" />,
      path: '/Educacao',
    },
    {
      label: 'Comunidade',
      icon: <UsersThree size="1.2rem" />,
      path: '/recommended-posts',
    },
    {
      label: isPremium ? 'Plano' : 'Seja Premium',
      icon: <Crown size="1.2rem" />,
      path: isPremium ? '/profile-edit' : '/pagamentos',
    },
    {
      label: 'Configurações',
      icon: <GearSix size="1.2rem" />,
      path: '/profile-edit',
    },
    {
      label: 'Suporte',
      icon: <Question size="1.2rem" />,
      path: '/suporte',
    },
  ];
  const navListSubChannelShort = [
    {
      icon: <UserGear size="1.2rem" />,
      isAdmin: true,
    },
    {
      icon: <SquaresFour size="1.2rem" />,
    },
    {
      icon: <Wallet size="1.2rem" id="bottom-wallet"/>,
    },
    {
      icon: <Cube size="1.2rem" id="renda-fixa"/>,
    },
    {
      icon: <ChartLineUp size="1.2rem" id="analise-ativos" />,
    },
    {
      icon: <CurrencyCircleDollar size="1.2rem" id="renda-passiva" />,
    },
    {
      icon: <Calculator size="1.2rem" id="simulador" />,
    },
    {
      icon: <Bank size="1.2rem" id="imposto-renda" />,
    },
    {
      icon: <Books size="1.2rem" id="cursos-gratuitos" />,
    },
    {
      icon: <Video size="1.2rem" id="tutoriais" />,
    },
    {
      icon: <GraduationCap size="1.2rem" />,
    },
    {
      icon: <UsersThree size="1.2rem" />,
    },
    {
      icon: <Crown size="1.2rem" />,
    },
    {
      icon: <GearSix size="1.2rem" />,
    },
    {
      icon: <Question size="1.2rem" />,
    },
    // {
    //   icon: <ChatCircleText size="1.2rem" />,
    // },
  ];

  const navMap = navList.map((nav, i) => {
    if (!nav.submenu) {
      return {
        key: nav.key || i.toString(),
        icon: nav.icon,
        label: (
          <span
            style={{
              color: 'var(--Gray-gray-600, #6A717E)',
              fontFamily: 'Poppins',
              fontSize: '0.8280rem',
              fontStyle: 'normal',
              fontWeight: '400',
              lineHeight: '100%',
            }}
          >
            {nav.label}
          </span>
        ),
        onClick: () => history.push(nav.path),
      };
    } else {
      return {
        key: nav.key || i.toString(),
        icon: nav.icon,
        label: (
          <span
            style={{
              color: 'var(--Gray-gray-600, #6A717E)',
              fontFamily: 'Poppins',
              fontSize: '0.8280rem',
              fontStyle: 'normal',
              fontWeight: '400',
              lineHeight: '100%',
            }}
          >
            {nav.label}
          </span>
        ),
        onMouseEnter: nav.key === 'cursos-ibox6' ? () => setOpenKeys((keys) => keys.includes('cursos-ibox6') ? keys : [...keys, 'cursos-ibox6']) : undefined,
        children: nav.submenu.map((subNav) => ({
          key: subNav.path,
          className: subNav.path === '/cursos-premium' ? 'premium-course-item' : undefined,
          label: (
            <span
              style={{
                color: 'var(--Gray-gray-600, #6A717E)',
                fontFamily: 'Poppins',
                fontSize: '0.8280rem',
                fontStyle: 'normal',
                fontWeight: '400',
                lineHeight: '100%',
              }}
            >
              {subNav.label}
            </span>
          ),
          onClick: () => navigateCourse(subNav.path),
        })),
      };
    }
  });

  const navMapNoChannel = navListSubChannel.map((nav, i) => {
    if (!nav.submenu) {
      if (nav.path === '/suporte') {
        return {
          key: i.toString(),
          icon: nav.icon,
          label: nav.label,
          onClick: () => window.open(whatsAppLinkApi),
        };
      }

      return {
        key: nav.key || i.toString(),
        icon: nav.icon,
        label: nav.label,
        onClick: () => history.push(nav.path),
      };
    } else {
      return {
        key: nav.key || i.toString(),
        icon: nav.icon,
        label: nav.label,
        onMouseEnter: nav.key === 'cursos-ibox6' ? () => setOpenKeys((keys) => keys.includes('cursos-ibox6') ? keys : [...keys, 'cursos-ibox6']) : undefined,
        children: nav.submenu.map((subNav) => {
          if (subNav.block) {
            return {
              key: subNav.path,
              label: subNav.label,
              className: 'block',
              onClick: () =>
                handleToast(true, `${subNav.label} está em desemvolvimento`),
            };
          } else {
            return {
              key: subNav.path,
          className: subNav.path === '/cursos-premium' ? 'premium-course-item' : undefined,
              label: subNav.label,
              onClick: () => navigateCourse(subNav.path),
            };
          }
        }),
      };
    }
  });

  const isAdmin = permissions.includes('Admin');

  const navMapNoChannelShort = navListSubChannelShort.map((nav, i) => {
    if (isAdmin && i === 0) {
      return {
        key: i.toString(),
        icon: nav.icon,
      };
    }
    if (!isAdmin && i === 0) {
      return null;
    }
    return {
      key: i.toString(),
      icon: nav.icon,
    };
  });

  const handleHover = () => {
    if (hoveredRef.current) {
      const larguraAtual = hoveredRef.current.offsetWidth;

      setWidth((state) => {
        state = larguraAtual;
        return state;
      });
    }
  };
  const handleUnHover = () => {
    setWidth(60);
  };

  return (
    <>
      <Container
        isOpen={width >= 61}
        title={title}
        isMobile={isMobile}
        onMouseOver={handleHover}
        onMouseLeave={handleUnHover}
        ref={hoveredRef}
        isBlackScreen={window.location.pathname === '/admin-painel/dashboard'}
      >
        <Layout>
          {isAdmin ? (
            <Sider width={250} className="site-layout-background">
              <Menu
                mode="inline"
                openKeys={openKeys}
                onOpenChange={setOpenKeys}
                defaultSelectedKeys={[location.pathname]}
                style={{
                  borderRight: 0,
                  background:
                    window.location.pathname === '/admin-painel/dashboard' &&
                    '#303030',
                  color:
                    window.location.pathname === '/admin-painel/dashboard' &&
                    'white',
                }}
                // items={navMap}
                items={width >= 61 ? navMap : navMapNoChannelShort}
              />
            </Sider>
          ) : (
            <Sider width={250} className="site-layout-background">
              <Menu
                mode="inline"
                openKeys={openKeys}
                onOpenChange={setOpenKeys}
                selectedKeys={[location.pathname + location.search]}
                style={{
                  borderRight: 0,
                }}
                // items={navMapNoChannel}
                items={width >= 61 ? navMapNoChannel : navMapNoChannelShort}
              />
            </Sider>
          )}
        </Layout>
        <footer>
          <span
            onClick={() => {
              setUser({});
              dispatch(logout(history));
            }}
          >
            {width >= 61 ? (
              <>
                <SignOut size={18} className="logoutIcon" /> Sair
              </>
            ) : (
              <SignOut size={18} className="logoutIcon" />
            )}
          </span>
        </footer>
      </Container>
    </>
  );
}
